export const DESKTOP_ARTICLES_PER_PAGE = 3;
export const MOBILE_ARTICLES_PER_PAGE = 3;
